import React, { useEffect, useState } from 'react'
import logo from '../../assets/images/logoa.png'
import avtar from '../../assets/images/user/avatar-1.jpg'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useProfile } from '../Context/ProfileContext'

const Sidebar = ({ isHidden }) => {
    const { profile, fetchProfile } = useProfile();
    const location = useLocation();
    const pathname = location.pathname;
    const navigate = useNavigate();

    // Derive activeMenu from pathname
    const getActiveMenuFromPath = () => {
        if (pathname.startsWith('/users')) return 'users';
        if (pathname.startsWith('/faqs')) return 'faqs';
        if (pathname.startsWith('/testimonials')) return 'testimonials';
        if (pathname.startsWith('/categories')) return 'categories';
        if (pathname.startsWith('/cms')) return 'cms';
        if (pathname.startsWith('/banner')) return 'banner';
        if (pathname.startsWith('/products')) return 'products';
        if (pathname.startsWith('/newsletter')) return 'newsletter';
        if (pathname.startsWith('/footer')) return 'footer';
        if (pathname.startsWith('/coupons')) return 'coupons';
        if (pathname.startsWith('/shipping')) return 'shipping';
        if (pathname.startsWith('/orders')) return 'orders';
        if (pathname.startsWith('/about')) return 'about';
        if (pathname.startsWith('/contact')) return 'contact';
        if (pathname === '/' || pathname === '/dashboard') return '/';
        return null;
    };

    const [openMenu, setOpenMenu] = useState(getActiveMenuFromPath());
    const [activeMenu, setActiveMenu] = useState(getActiveMenuFromPath());


    // Reset open menu when path changes (optional)
    useEffect(() => {
        const currentMenu = getActiveMenuFromPath();
        setActiveMenu(currentMenu);
        setOpenMenu(currentMenu);
    }, [pathname]);

    const handleMenuToggle = (menuKey) => {
        setOpenMenu(prev => (prev === menuKey ? null : menuKey));
    };

    const handleLogout = async (e) => {
        e.preventDefault();
        localStorage.removeItem("token");
        localStorage.clear();
        navigate('/login');
    };

    useEffect(() => {
        fetchProfile();
    }, []);

    return (
        <nav className={`pc-sidebar ${isHidden ? 'pc-sidebar-hide' : ''}`}>
            <div className="navbar-wrapper">
                <div className="m-header text-center">
                    <Link to="/" className="b-brand text-primary">
                        <img src={logo} className="img-fluid logo-lg" alt="logo" />
                    </Link>
                </div>
                <div className="navbar-content">
                    <div className="card pc-user-card">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0">
                                    <img src={profile?.profileImage ? `${profile?.profileImage}` : avtar} alt="user" className="user-avtar wid-45 rounded-circle" />
                                </div>
                                <div className="flex-grow-1 ms-3 me-2">
                                    <h6 className="mb-0">{profile?.fullName}</h6>
                                    <small>Administrator</small>
                                </div>
                                <a className="btn btn-icon btn-link-secondary avtar" data-bs-toggle="collapse" href="#pc_sidebar_userlink">
                                    <i className="fas fa-sort pc-icon"></i>
                                </a>
                            </div>
                            <div className="collapse pc-user-links" id="pc_sidebar_userlink">
                                <div className="pt-3">
                                    <Link to="/profile">
                                        <i className="fas fa-user" />
                                        <span>My Account</span>
                                    </Link>
                                    <Link to="#" onClick={handleLogout}>
                                        <i className="fas fa-power-off" />
                                        <span>Logout</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ul className="pc-navbar">
                        <li className="pc-item pc-caption">
                            <label>Navigation</label>
                        </li>
                        <li className={`pc-item ${pathname === '/' ? 'active' : ''}`}>
                            <Link to="/" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fas fa-chart-line pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Dashboard</span>
                            </Link>
                        </li>

                        {/* Users */}
                        <li className="pc-item pc-caption">
                            <label>Users</label>
                        </li>
                        <li className={`pc-item pc-hasmenu ${openMenu === 'users' ? 'pc-trigger' : ''} ${activeMenu === 'users' ? 'active' : ''}`}>
                            <Link to="#" className="pc-link" onClick={() => handleMenuToggle('users')}>
                                <span className="pc-micon">
                                    <i className="fas fa-users pc-icon"></i>
                                </span>
                                <span className="pc-mtext">User Management</span>
                                <span className="pc-arrow"><i className="fas fa-chevron-right"></i></span>
                            </Link>
                            <ul className={`pc-submenu ${openMenu === 'users' ? 'd-block' : ''}`}>
                                <li className={`pc-item ${pathname === '/users/add-user' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/users/add-user">Add User</Link>
                                </li>
                                <li className={`pc-item ${pathname === '/users/user-list' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/users/user-list">User List</Link>
                                </li>
                            </ul>
                        </li>

                        {/* Category */}
                        <li className="pc-item pc-caption">
                            <label>Category</label>
                        </li>
                        <li className={`pc-item pc-hasmenu ${openMenu === 'categories' ? 'pc-trigger' : ''} ${activeMenu === 'categories' ? 'active' : ''}`}>
                            <Link to="#" className="pc-link" onClick={() => handleMenuToggle('categories')}>
                                <span className="pc-micon">
                                    <i className="fas fa-layer-group pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Category Management</span>
                                <span className="pc-arrow"><i className="fas fa-chevron-right"></i></span>
                            </Link>
                            <ul className={`pc-submenu ${openMenu === 'categories' ? 'd-block' : ''}`}>
                                <li className={`pc-item ${pathname === '/categories/add-category' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/categories/add-category">Add Category</Link>
                                </li>
                                <li className={`pc-item ${pathname === '/categories/category-list' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/categories/category-list">Category List</Link>
                                </li>
                            </ul>
                        </li>

                        {/* Product */}
                        <li className="pc-item pc-caption">
                            <label>Product</label>
                        </li>
                        <li className={`pc-item pc-hasmenu ${openMenu === 'products' ? 'pc-trigger' : ''} ${activeMenu === 'products' ? 'active' : ''}`}>
                            <Link to="#" className="pc-link" onClick={() => handleMenuToggle('products')}>
                                <span className="pc-micon">
                                    <i className="fas fa-warehouse pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Product Management</span>
                                <span className="pc-arrow"><i className="fas fa-chevron-right"></i></span>
                            </Link>
                            <ul className={`pc-submenu ${openMenu === 'products' ? 'd-block' : ''}`}>
                                <li className={`pc-item ${pathname === '/products/add-product' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/products/add-product">Add Product</Link>
                                </li>
                                <li className={`pc-item ${pathname === '/products/product-list' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/products/product-list">Product List</Link>
                                </li>
                            </ul>
                        </li>

                        {/* Coupons */}
                        <li className="pc-item pc-caption">
                            <label>Coupons</label>
                        </li>
                        <li className={`pc-item pc-hasmenu ${openMenu === 'coupons' ? 'pc-trigger' : ''} ${activeMenu === 'coupons' ? 'active' : ''}`}>
                            <Link to="#" className="pc-link" onClick={() => handleMenuToggle('coupons')}>
                                <span className="pc-micon">
                                    <i className="fas fa-gift pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Coupon Management</span>
                                <span className="pc-arrow"><i className="fas fa-chevron-right"></i></span>
                            </Link>
                            <ul className={`pc-submenu ${openMenu === 'coupons' ? 'd-block' : ''}`}>
                                <li className={`pc-item ${pathname === '/coupons/add-coupon' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/coupons/add-coupon">Add Coupon</Link>
                                </li>
                                <li className={`pc-item ${pathname === '/coupons/coupon-list' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/coupons/coupon-list">Coupon List</Link>
                                </li>
                            </ul>
                        </li>
                        {/* Banner */}
                        <li className="pc-item pc-caption">
                            <label>Manage Banner</label>
                        </li>
                        <li className={`pc-item ${pathname === '/banner/update-banner' ? 'active' : ''}`}>
                            <Link to="/banner/update-banner" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fa-solid fa-images pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Banner</span>
                            </Link>
                        </li>
                        {/* Banner */}
                        <li className="pc-item pc-caption">
                            <label>Manage Contact Us</label>
                        </li>
                        <li className={`pc-item ${pathname === '/contact/list-contact' ? 'active' : ''}`}>
                            <Link to="/contact/list-contact" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fa-solid fa-phone pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Contact Us</span>
                            </Link>
                        </li>

                        {/* Testimonial */}
                        <li className="pc-item pc-caption">
                            <label>Testimonial</label>
                        </li>
                        <li className={`pc-item pc-hasmenu ${openMenu === 'testimonials' ? 'pc-trigger' : ''} ${activeMenu === 'testimonials' ? 'active' : ''}`}>
                            <Link to="#" className="pc-link" onClick={() => handleMenuToggle('testimonials')}>
                                <span className="pc-micon">
                                    <i className="fas fa-comment-dots pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Testimonial Management</span>
                                <span className="pc-arrow"><i className="fas fa-chevron-right"></i></span>
                            </Link>
                            <ul className={`pc-submenu ${openMenu === 'testimonials' ? 'd-block' : ''}`}>
                                <li className={`pc-item ${pathname === '/testimonials/add-testimonial' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/testimonials/add-testimonial">Add Testimonial</Link>
                                </li>
                                <li className={`pc-item ${pathname === '/testimonials/testimonial-list' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/testimonials/testimonial-list">Testimonial List</Link>
                                </li>
                            </ul>
                        </li>

                        {/* FAQs */}
                        <li className="pc-item pc-caption">
                            <label>FAQs</label>
                        </li>
                        <li className={`pc-item pc-hasmenu ${openMenu === 'faqs' ? 'pc-trigger' : ''} ${activeMenu === 'faqs' ? 'active' : ''}`}>
                            <Link to="#" className="pc-link" onClick={() => handleMenuToggle('faqs')}>
                                <span className="pc-micon">
                                    <i className="fa-solid fa-circle-question pc-icon"></i>
                                </span>
                                <span className="pc-mtext">FAQs Management</span>
                                <span className="pc-arrow"><i className="fas fa-chevron-right"></i></span>
                            </Link>
                            <ul className={`pc-submenu ${openMenu === 'faqs' ? 'd-block' : ''}`}>
                                <li className={`pc-item ${pathname === '/faqs/faq-list' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/faqs/faq-list">FAQs List</Link>
                                </li>
                                <li className={`pc-item ${pathname === '/faqs/add-faq' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/faqs/add-faq">Add FAQs</Link>
                                </li>
                            </ul>
                        </li>

                        {/* CMS */}
                        <li className="pc-item pc-caption">
                            <label>CMS</label>
                        </li>
                        <li className={`pc-item pc-hasmenu ${openMenu === 'cms' ? 'pc-trigger' : ''} ${activeMenu === 'cms' ? 'active' : ''}`}>
                            <Link to="#" className="pc-link" onClick={() => handleMenuToggle('cms')}>
                                <span className="pc-micon">
                                    <i className="fas fa-sliders-h pc-icon"></i>
                                </span>
                                <span className="pc-mtext">CMS Management</span>
                                <span className="pc-arrow"><i className="fas fa-chevron-right"></i></span>
                            </Link>
                            <ul className={`pc-submenu ${openMenu === 'cms' ? 'd-block' : ''}`}>
                                <li className={`pc-item ${pathname === '/cms/add-cms' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/cms/add-cms">Add CMS</Link>
                                </li>
                                <li className={`pc-item ${pathname === '/cms/cms-list' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/cms/cms-list">CMS List</Link>
                                </li>
                            </ul>
                        </li>

                        {/* Newsletters */}
                        <li className="pc-item pc-caption">
                            <label>Newsletters</label>
                        </li>
                        <li className={`pc-item ${pathname === '/newsletter/newsletter-list' ? 'active' : ''}`}>
                            <Link to="/newsletter/newsletter-list" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fa-solid fa-envelope pc-icon"></i>
                                </span>
                                <span className="pc-mtext">All Newsletters</span>
                            </Link>
                        </li>

                        {/* Footer */}
                        <li className="pc-item pc-caption">
                            <label>Shipping Setting</label>
                        </li>
                        <li className={`pc-item ${pathname === '/shipping/update-shipping' ? 'active' : ''}`}>
                            <Link to="/shipping/update-shipping" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fa-solid fa-truck pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Shipping Setting</span>
                            </Link>
                        </li>
                        <li className="pc-item pc-caption">
                            <label>About Page</label>
                        </li>
                        <li className={`pc-item ${pathname === '/about/update-about' ? 'active' : ''}`}>
                            <Link to="/about/update-about" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fa-solid fa-user-tie pc-icon"></i>
                                </span>
                                <span className="pc-mtext">About Management</span>
                            </Link>
                        </li>
                        {/* Footer */}
                        <li className="pc-item pc-caption">
                            <label>Order Management</label>
                        </li>
                        <li className={`pc-item ${pathname === '/orders/list-orders' ? 'active' : ''}`}>
                            <Link to="/orders/list-orders" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fa-solid fa-clipboard-list pc-icon"></i>
                                </span>
                                <span className="pc-mtext">All Orders</span>
                            </Link>
                        </li>
                        {/* Footer */}
                        <li className="pc-item pc-caption">
                            <label>Manage Footer</label>
                        </li>
                        <li className={`pc-item ${pathname === '/footer/update-footer' ? 'active' : ''}`}>
                            <Link to="/footer/update-footer" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fa-solid fa-file-lines pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Footer Info</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default Sidebar
